import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ShopRoutingModule } from "./shop-routing.module";
import { PaginationComponent } from "./pagination/pagination.component";
import { AllProducts } from "./allProducts";
import { CatogeryProducts } from "./CatogeryProducts";
import { PeoductsSearch } from "./searchProducts";
import { DeferLoadModule } from "@trademe/ng-defer-load";
import { LoaderModule } from "../../modules/loader-module/loader-module";
import { NgxPaginationModule } from "ngx-pagination";

@NgModule({
  declarations: [
    AllProducts,
    CatogeryProducts,
    PaginationComponent,
    PeoductsSearch
  ],
  imports: [
    CommonModule,
    DeferLoadModule,
    ShopRoutingModule,
    LoaderModule,
    NgxPaginationModule
  ]
})
export class ShopModule {}
